import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SvgIcon } from '@mui/material';

import GoogleIcon from '../../icons/googleColorV2.svg';

import { SocialButton } from './SocialButton';

interface IProps {
	onClick: VoidFunction;
}
export const GoogleButton: FC<IProps> = (props) => {
	const { t } = useTranslation('socialLogin');
	const { onClick } = props;

	const handleClick = () => {
		onClick();
	};
	return (
		<SocialButton
			name="google"
			text={t('button.google')}
			onClick={handleClick}
			icon={<SvgIcon fontSize="small" component={GoogleIcon} />}
		/>
	);
};
